import axios from '@axios'

const PREFIX = '/tipos-tributacao'

export default {

  getTiposTributacao(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getTipoTributacao(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  createTipoTributacao(tributacao, sobrescreveSN, sobrescreveMEI, sobrescreveRH, sobrescreveConsultoria, sobrescreveDomestica) {
    return axios.post(`${PREFIX}/add?sobrescreveSN=${sobrescreveSN}&sobrescreveMEI=${sobrescreveMEI}&sobrescreveRH=${sobrescreveRH}&sobrescreveConsultoria=${sobrescreveConsultoria}&sobrescreveDomestica=${sobrescreveDomestica}`, tributacao)
  },

  updateTipoTributacao(id, tributacao, sobrescreveSN, sobrescreveMEI, sobrescreveRH, sobrescreveConsultoria, sobrescreveDomestica) {
    return axios.put(`${PREFIX}/${id}?sobrescreveSN=${sobrescreveSN}&sobrescreveMEI=${sobrescreveMEI}&sobrescreveRH=${sobrescreveRH}&sobrescreveConsultoria=${sobrescreveConsultoria}&sobrescreveDomestica=${sobrescreveDomestica}`, tributacao)
  },

  deleteTipoTributacao(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  getTributacoesResumidas(filtros) {
    return axios.post(`${PREFIX}/resumida`, filtros)
  },

  existeTributacaoVinculoChecklist(id) {
    return axios.get(`${PREFIX}/existe-vinculo/${id}`)
  },

  deleteAll(idList) {
    return axios.delete(`${PREFIX}/lote`, { data: idList })
  },

  verificaTributacoesExistente(id, tipoTributacao) {
    return axios.get(`${PREFIX}/existe-tributacao?id=${id}&tributacao=${tipoTributacao}`)
  },

}
